var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoteles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#007DC3;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 12,
    className: "st0",
    width: 12.3,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 5.2,
    className: "st0",
    width: 15,
    height: 39.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 16.1,
    className: "st0",
    width: 12.3,
    height: 28.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39.3,
    className: "st0",
    width: 4.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36.7,
    y1: 36.6,
    x2: 40.7,
    y2: 36.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36.7,
    y1: 32.5,
    x2: 40.7,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36.7,
    y1: 28.4,
    x2: 40.7,
    y2: 28.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36.7,
    y1: 24.3,
    x2: 40.7,
    y2: 24.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36.7,
    y1: 20.2,
    x2: 40.7,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 36.6,
    x2: 13.4,
    y2: 36.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 32.5,
    x2: 13.4,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 28.4,
    x2: 13.4,
    y2: 28.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 24.3,
    x2: 13.4,
    y2: 24.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 20.2,
    x2: 13.4,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.4,
    y1: 16.1,
    x2: 13.4,
    y2: 16.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 33.9,
    x2: 23,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 29.8,
    x2: 23,
    y2: 29.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 25.7,
    x2: 23,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 21.6,
    x2: 23,
    y2: 21.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 17.5,
    x2: 23,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 13.4,
    x2: 23,
    y2: 13.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.7,
    y1: 9.3,
    x2: 23,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 33.9,
    x2: 28.4,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 29.8,
    x2: 28.4,
    y2: 29.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 25.7,
    x2: 28.4,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 21.6,
    x2: 28.4,
    y2: 21.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 17.5,
    x2: 28.4,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 13.4,
    x2: 28.4,
    y2: 13.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.2,
    y1: 9.3,
    x2: 28.4,
    y2: 9.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoteles);
export default __webpack_public_path__ + "static/media/hoteles.ce8a8e9215b9a83a4cd6309ddb1081fc.svg";
export { ForwardRef as ReactComponent };